import { useTable, useRowSelect, usePagination } from "react-table";
import { useMemo } from "react";
import DefaultColumnFilter from "./SD_einsehen/TabellenBausteine";
import { useFilters, useGlobalFilter } from "react-table";
import { useEffect, useState } from "react";

export default function TableWithInputsAndFilter ({ 
    columns, data, hiddenColumns, 
    updateMethod, deleteChange, deleteSpecificRow,
    registerStateChange, states, selectAll, whichDe}) {

    const [allTrue, setAllTrue] = useState(true);
    const [allFalse, setAllFalse] = useState(false);

    const defaultColumn = useMemo(() => ({
        Filter: DefaultColumnFilter
    }),[])

    useEffect(() => {
        if (Object.values(states).includes(false) && Object.values(states).includes(true)) {
            setAllTrue(true);
            setAllFalse(true);
        } else if (!Object.values(states).includes(false)) {
            setAllFalse(true);
            setAllTrue(false);
        } else if (!Object.values(states).includes(true)) {
            setAllFalse(false);
            setAllTrue(true);
        }
    }, [states]);

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        prepareRow,
        page, // Instead of using 'rows', we'll use page,
            // which has only the rows for the active page

        // The rest of these things are super handy, too ;)
        canPreviousPage,
        canNextPage,
        pageOptions,
        pageCount,
        gotoPage,
        nextPage,
        previousPage,
        setPageSize,
        state: { pageIndex, pageSize },
      } = useTable(
        {
          columns,
          data,
          states,
          updateMethod,
          deleteChange,
          whichDe,
          deleteSpecificRow,
          registerStateChange,
          selectAll,
          defaultColumn, // Be sure to pass the defaultColumn option
          initialState: {
              hiddenColumns: hiddenColumns,
              pageIndex: 0
          }
        },
        useFilters, // useFilters!
        useGlobalFilter, // useGlobalFilter!
        usePagination,
        useRowSelect,
        hooks => {
            hooks.visibleColumns.push(columns => [
                ...columns
            ])
        }
      )

    return (
        <>
        <table {...getTableProps()} className="general-table">
            <thead>
                {headerGroups.map(headerGroup => (
                    <tr {...headerGroup.getHeaderGroupProps()}>
                        {headerGroup.headers.filter(column => !column.unused).map(column => (
                            <th {...column.getHeaderProps()} style={{border: "1px solid whitesmoke", width: `${columns.filter(col => col.Header === column.render('Header')).map(c => c.width)}`}}>
                                {column.render('Header')}
                                <div>
                                    {column.canFilter ? column.render('Filter') : null}
                                </div>
                            </th>
                        ))}
                    </tr>
                ))}
            </thead>
            <tbody {...getTableBodyProps()} className="general-table-body">
                {page.map((row, i) => {
                    prepareRow(row)
                    return (
                        <tr {...row.getRowProps()} className={i % 2 === 0 ? "even-page" : "odd-page"} >
                            {row.cells.filter(cell => !cell.render('Cell').props.column.unused).map(cell => {
                                return <td {...cell.getCellProps()} className="general-table-cell" style={{width: `${columns.filter(col => col.Header === cell.render('Header')).map(c => c.width)}`}}>
                                            {cell.render('Cell')} </td>
                                }
                            )}
                        </tr>
                    )
                })}
            </tbody>
        </table>
        {/* 
        Pagination can be built however you'd like. 
        This is just a very basic UI implementation:
      */}
        <div className="pagination">
        <select
            value={pageSize}
            onChange={e => {
            setPageSize(Number(e.target.value))
            }}
        >
            {[10, 25, 50, 100].map(pageSize => (
            <option key={pageSize} value={pageSize}>
                Zeige {pageSize}
            </option>
            ))}
        </select>
        <button onClick={() => gotoPage(0)} disabled={!canPreviousPage}>
            {'<<'}
        </button>{' '}
        <button onClick={() => previousPage()} disabled={!canPreviousPage}>
            {'<'}
        </button>{' '}
        <button onClick={() => nextPage()} disabled={!canNextPage}>
            {'>'}
        </button>{' '}
        <button onClick={() => gotoPage(pageCount - 1)} disabled={!canNextPage}>
            {'>>'}
        </button>{' '}
        <span >
            Seite{' '}
            <strong>
            {pageIndex + 1} von {pageOptions.length}
            </strong>{' '}
        </span>
        <span className="auswahl-bttn">
            {allTrue && 
                <button onClick={e => selectAll(e, true)}>Alle auswählen </button>}
            {allFalse && 
                <button onClick={e => selectAll(e, false)}>Alle abwählen</button>}
        </span>
        </div >
        </>
    )    
}
